import { render, staticRenderFns } from "./BarCharts.vue?vue&type=template&id=bfc34e14&scoped=true"
import script from "./BarCharts.vue?vue&type=script&lang=js"
export * from "./BarCharts.vue?vue&type=script&lang=js"
import style0 from "./BarCharts.vue?vue&type=style&index=0&id=bfc34e14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_cache-lo_875f195a559ab6cb5ed9ea4190ad0331/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfc34e14",
  null
  
)

export default component.exports